// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FCKeI","box":"styles_box__f1rmu","icon":"styles_icon__cYgFU"};